import React, { useEffect, useState } from 'react'


import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { ChevronDownIcon } from '@heroicons/react/16/solid';
import Loader from '../../../utils/Loader';

const FinanceCustomerEdite = ({ close, FinancesId }) => {
   
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        address: "",
    });

    const navigate = useNavigate();
    const [validation, setvalidation] = useState([])
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(true)


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const fetchFinancesData = async () => {
        setLoading(true)
        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(`public/api/finance-customers/${FinancesId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            });

            
            setFormData({
                name: response?.data?.name,
                phone:response?.data?.phone,
                email: response?.data?.email,
                address: response?.data?.email,
            })

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm");
            }
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchFinancesData()
    }, [])

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem("token");
            const response = await axios.put(`public/api/finance-customers/update/${FinancesId}`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                   'Content-Type': 'application/json',
                },
            });
         
            if (response.data) {
                toast.success(response.data.message);
                close();
            } 
        } catch (error) {
            
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm");
            }
            setvalidation(error.response.data);
        }
    }

    if (loading) {
        return (
            <Loader />
        )
    }

    if (error) {    
        return (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
                <div className="bg-white rounded-lg shadow-lg p-8 max-w-md">
                    <div className="flex items-center justify-center mb-6">
                        <svg
                            className="h-12 w-12 text-red-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                        </svg>
                    </div>

                    <p className="text-gray-600 mb-8 text-center">
                        Please check your internet connection and try again.
                    </p>
                    <div className="flex justify-center">
                        <button
                            className="bg-[#0f172a] hover:bg-teal-900 text-white font-semibold py-2 px-4 rounded transition duration-300"
                        // onClick={fetch}
                        >
                            Try Again
                        </button>
                    </div>
                </div>
            </div>
        )
    }



    return (
        <div className='p-6'>

            <div className="flex items-center justify-end  w-full">
                <button
                    onClick={close}
                    className="text-gray-500 hover:text-gray-700 focus:outline-none"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="black"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                        ></path>
                    </svg>
                </button>
            </div>
            <div className='flex flex-col items-center mt-6  '>
                <div className="bg-blue-500 text-white p-3  rounded-full">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="40" height="40" color="#000000" fill="none">
                        <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                        <circle cx="12" cy="7.5" r="3.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                    </svg>
                </div>
                <h1 className='text-3xl font-bold mt-4'>Add Finanace Customer</h1>

                <p className="text-gray-600 mt-2 text-center">
                    Complete the form below to add a new Finanace Customer to your chit fund.
                    All fields marked with <span className="text-red-500">*</span> are required.
                </p>
            </div>
            <div className=' border-b-2 mt-4 '></div>

            <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 mt-4 gap-6">

                    {/* Name */}
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                            <span className='border bg-blue-100 rounded-full p-1'>

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#bd10e0" fill="none">
                                    <path d="M18.5 20V17.9704C18.5 16.7281 17.9407 15.5099 16.8103 14.9946C15.4315 14.3661 13.7779 14 12 14C10.2221 14 8.5685 14.3661 7.18968 14.9946C6.05927 15.5099 5.5 16.7281 5.5 17.9704V20" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                    <circle cx="12" cy="7.5" r="3.5" stroke="#bd10e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></circle>
                                </svg>
                            </span> Name  <span className='text-lg'> *</span>
                        </label>

                        <input
                            id="name"
                            name="name"
                            type="text"
                            placeholder="Enter name"
                            value={formData.name}
                            onChange={handleChange}
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                        <p className="text-red-600 text-sm mt-1">{validation.errors?.name}</p>
                    </div>

                    {/* Phone */}
                    <div>
                        <label htmlFor="phone"
                            className="block text-sm font-medium text-gray-700 flex items-center gap-2"
                        >

                            <span className='border bg-red-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="13" height="13" color="#417505" fill="none">
                                    <path d="M9.1585 5.71223L8.75584 4.80625C8.49256 4.21388 8.36092 3.91768 8.16405 3.69101C7.91732 3.40694 7.59571 3.19794 7.23592 3.08785C6.94883 3 6.6247 3 5.97645 3C5.02815 3 4.554 3 4.15597 3.18229C3.68711 3.39702 3.26368 3.86328 3.09497 4.3506C2.95175 4.76429 2.99278 5.18943 3.07482 6.0397C3.94815 15.0902 8.91006 20.0521 17.9605 20.9254C18.8108 21.0075 19.236 21.0485 19.6496 20.9053C20.137 20.7366 20.6032 20.3131 20.818 19.8443C21.0002 19.4462 21.0002 18.9721 21.0002 18.0238C21.0002 17.3755 21.0002 17.0514 20.9124 16.7643C20.8023 16.4045 20.5933 16.0829 20.3092 15.8362C20.0826 15.6393 19.7864 15.5077 19.194 15.2444L18.288 14.8417C17.6465 14.5566 17.3257 14.4141 16.9998 14.3831C16.6878 14.3534 16.3733 14.3972 16.0813 14.5109C15.7762 14.6297 15.5066 14.8544 14.9672 15.3038C14.4304 15.7512 14.162 15.9749 13.834 16.0947C13.5432 16.2009 13.1588 16.2403 12.8526 16.1951C12.5071 16.1442 12.2426 16.0029 11.7135 15.7201C10.0675 14.8405 9.15977 13.9328 8.28011 12.2867C7.99738 11.7577 7.85602 11.4931 7.80511 11.1477C7.75998 10.8414 7.79932 10.457 7.90554 10.1663C8.02536 9.83828 8.24905 9.56986 8.69643 9.033C9.14586 8.49368 9.37058 8.22402 9.48939 7.91891C9.60309 7.62694 9.64686 7.3124 9.61719 7.00048C9.58618 6.67452 9.44362 6.35376 9.1585 5.71223Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                </svg>
                            </span>
                            Phone Number {""}
                            <span className='text-lg'> *</span>
                        </label>
                        <input
                            id="phone"
                            name="phone"
                            type="number"
                            placeholder="Enter phone"
                            value={formData.phone}
                            onChange={handleChange}
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                        <p className="text-red-600 text-sm mt-1">{validation.errors?.phone}</p>
                    </div>

                    {/* Email */}
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700 flex items-center gap-2">
                            <span className='border bg-red-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" color="#f5a623" fill="none">
                                    <path d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                    <path d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
                                </svg>
                            </span> Email
                        </label>
                        <input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="Enter email"
                            value={formData.email}
                            onChange={handleChange}
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                        <p className="text-red-600 text-sm mt-1">{validation.errors?.email}</p>
                    </div>

                    {/* Address */}
                    <div className=''>
                        <label htmlFor="address" className="block text-sm font-medium text-gray-700 flex items-center gap-2">



                            <span className='border bg-green-100 rounded-full p-1'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" color="#7ed321" fill="none">
                                    <path d="M9.06165 4.82633L3.23911 9.92134C2.7398 10.3583 3.07458 11.1343 3.76238 11.1343C4.18259 11.1343 4.52324 11.4489 4.52324 11.8371V15.0806C4.52324 17.871 4.52324 19.2662 5.46176 20.1331C6.40029 21 7.91082 21 10.9319 21H13.0681C16.0892 21 17.5997 21 18.5382 20.1331C19.4768 19.2662 19.4768 17.871 19.4768 15.0806V11.8371C19.4768 11.4489 19.8174 11.1343 20.2376 11.1343C20.9254 11.1343 21.2602 10.3583 20.7609 9.92134L14.9383 4.82633C13.5469 3.60878 12.8512 3 12 3C11.1488 3 10.4531 3.60878 9.06165 4.82633Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M12 16H12.009" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </span> Address
                        </label>
                        <input
                            id="address"
                            name="address"
                            type="text"
                            placeholder="Enter address"
                            value={formData.address}
                            onChange={handleChange}
                            className="mt-2 block w-full rounded-md border-gray-300 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                        />
                        <p className="text-red-600 text-sm mt-1">{validation.errors?.address}</p>
                    </div>





                </div>

                {/* Submit Button */}
                <div className="mt-6 text-right">
                    <button
                        type="submit"
                        className="inline-flex items-center gap-2 px-6 py-2 bg-[#0f172a] text-white text-sm font-medium rounded-md shadow hover:bg-teal-900 transition-all"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    )
}

export default FinanceCustomerEdite
